<template>
    <div class="messenger-page-selector" :class="modalSizeClass">
        <div class="page-card">
            <div class="page-card-header">
                <div class="page-card-header-title">{{$t("search.integration.selectMessengerAccount")}}</div>
            </div>
            <div class="page-card-body">
                <div class="page-card-body-content">
                    <div class="page-card-body-content-item" v-for="page in getMessengerPages()" :key="page.id">
                        <div class="page-card-body-content-item-image">
                            <img :src="page.picture.data.url" alt="page image" />
                        </div>
                        <div class="page-card-body-content-item-info">
                            <div class="page-card-body-content-item-info-name">
                                {{ page.name }}
                            </div>
                            <div class="page-card-body-content-item-info-username">
                                {{ page.username }}
                            </div>
                        </div>
                        <div class="page-card-body-content-item-action">
                            <a-button type="primary" @click="() => changeValue(page)"> {{ $t("message.select")}}</a-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import _ from "lodash";

export default Vue.extend({
    name: "MessengerPageSelector",
    props: {
        pages: {
            type: Array,
            required: true,
        },
        value: String,
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        getMessengerPages() {
            return this.pages;
        },
        changeValue(page) {
            this.clone = page;
        },
    },
    created() {
        this.clone = _.cloneDeep(this.value);
    },
    watch: {
        value: {
            deep: true,
            handler(value) {
                if (_.isEqual(value, this.clone)) return;
                this.clone = _.cloneDeep(value);
            },
        },
        clone: {
            deep: true,
            handler(value) {
                this.$emit("input", value);
            },
        },
    },
    computed: {
        modalSizeClass() {
            if (!this.pages) return '';
            if (this.pages.length >= 7) return 'large-modal';
            if (this.pages.length >= 4) return 'medium-modal';
            return 'small-modal';
        }
    }
});
</script>

<style scoped lang="scss">
.messenger-page-selector {
    .page-card {
        border-radius: 8px;
        overflow: hidden;
        background-color: #fff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

        .page-card-header {
            background-color: #f5f5f5;
            padding: 16px;

            .page-card-header-title {
                font-size: 18px;
                font-weight: 500;
            }
        }

        .page-card-body {
            .page-card-body-content {
                display: grid;
                grid-template-columns: 300px;
                gap: 16px;
                padding: 16px;
                margin: 0 auto;
                justify-items: center;
                justify-content: center;

                &:has(:nth-child(4)) {
                    grid-template-columns: repeat(3, minmax(300px, 1fr));
                }

                .page-card-body-content-item {
                    width: 300px;
                    display: flex;
                    align-items: center;
                    padding: 12px;
                    gap: 12px;
                    background-color: #fff;
                    border: 1px solid #e8e8e8;
                    border-radius: 8px;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

                    .page-card-body-content-item-image {
                        flex: 0 0 50px;

                        img {
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                            object-fit: cover;
                        }
                    }

                    .page-card-body-content-item-info {
                        flex: 1;
                        min-width: 0;
                        padding: 0 8px;

                        .page-card-body-content-item-info-name {
                            font-size: 14px;
                            font-weight: 500;
                            overflow: visible;
                        }

                        .page-card-body-content-item-info-username {
                            font-size: 12px;
                            color: #666;
                            overflow: visible;
                        }
                    }

                    .page-card-body-content-item-action {
                        flex: 0 0 auto;
                    }
                }
            }
        }
    }
}
</style>
